import React, { useMemo } from "react";
import { IntendedUsePageContent } from "@swo/storefront";
import { css } from "@emotion/react";
import { IntendedUseCardItem } from "./IntendedUseCardItem";
import { CSS_MQ } from "../../styles/breakpoints";

export const IntendedUseCards: React.FC<{
  items: IntendedUsePageContent["items"];
  activeProductCategoryFilters: Array<string>;
}> = ({ items, activeProductCategoryFilters }) => {
  const filteredItems = useMemo(
    () => filterItems(items, activeProductCategoryFilters),
    [activeProductCategoryFilters.join(",")],
  );

  const wrapperStyles = css`
    display: grid;

    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));

    ${CSS_MQ.atLeastLg} {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }
    ${CSS_MQ.atLeastXl} {
      grid-template-columns: repeat(4, minmax(0, 1fr));
    }

    gap: 24px;
    margin-top: 44px;
    ${CSS_MQ.atMostXs} {
      gap: 32px;
      margin-top: 32px;
    }
  `;

  return (
    <div css={wrapperStyles}>
      {filteredItems.map(card => (
        <IntendedUseCardItem key={JSON.stringify(card)} card={card} />
      ))}
    </div>
  );
};

function filterItems(items: IntendedUsePageContent["items"], activeProductCategoryFilters: Array<string>) {
  const activeProductCategoryFiltersSet = new Set(activeProductCategoryFilters);
  const hasActiveFilter = activeProductCategoryFiltersSet.size > 0;

  return !hasActiveFilter
    ? items
    : items.filter(item => {
        if (item.type !== "product-item") {
          return false;
        } else {
          return activeProductCategoryFiltersSet.has(item.category.key);
        }
      });
}
